import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { TableHr } from "../../components/budget/hr/TableHr";
import {
  _SAVE_CATEGORY_HUMAN_RESSOURCES,
  _SAVE_DATA_HUMAN_RESSOURCES,
} from "../../utils/constantsSave";
import { useEffect, useState } from "react";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import { Box } from "@mui/material";

export const InputHr = () => {
  const [saveData, setSaveData] = useState([]);
  const data = _SAVE_DATA_HUMAN_RESSOURCES;
  const save_name_category = _SAVE_CATEGORY_HUMAN_RESSOURCES;

  /**
   *
   */
  useEffect(() => {
    if (saveData.length > 0) {
      /** modify data for back refactoring */
      const modifiedData = saveData.map((d) => {
        return {
          ...d,
          activityName: "OVH",
        };
      });
      sendToFinancialData(modifiedData, save_name_category);
    }
  }, [saveData]);

  return (<>
    <BaseBudgetInput
      title="Input Human Ressources"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_HR}
      enableFlag="dataEntryEnableHr"
      TableComponent={TableHr}
      saveData={saveData}
      setSaveData={setSaveData}
      includeBaseBudgetSave={true}
      arrayData={data}
      saveNameCategory={save_name_category}
    />
    
  </>);
};
